import {Component, EventEmitter, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DropdownConfig, DropdownOption} from 'src/app/components/custom-dropdown/custom-dropdown.component';
import {
  FaqBuilder,
  InfoDropdown,
} from 'src/app/components/faq/faq.component';
import {FeatureType} from 'src/app/components/featured-plates/featured-plates.component';
import {
  PAGE_PLACEMENTS,
  PagePlacement,
} from 'src/app/components/page-placement/page-placement.component';
import {
  SidebarFilterConfig,
  SidebarFilterGroup,
  SidebarFilter
} from 'src/app/components/side-bar-filters/side-bar-filters.component';
import {
  GOOGLE_REDUCED_CHIPS,
  StickyConfig,
  StickyLink,
  StickyLinkGroup,
  StickyLinkType,
  THICKER_SELECTED_BORDER,
} from 'src/app/components/sticky-tabs/sticky-tabs.component';
import {BYOTermResponse} from 'src/app/models/byoTermResponse';
import {HttpLoadingResp} from 'src/app/models/httpLoadingResp';
import {NewReleaseResult} from 'src/app/models/newReleaseResult';
import {Registration} from 'src/app/models/registration';
import {QuickSignupService} from 'src/app/services/quick-signup-service';
import {RegistrationService} from 'src/app/services/registration-service';
import {SearchReqResponse, SearchService} from 'src/app/services/search-service';
import {UserService} from 'src/app/services/user-service';
import {SearchFilters} from '../search-results-page/search-results-page.component';
import GlobalFaqs from "../../global-faqs";

@Component({
  selector: 'pla-new-release-page',
  templateUrl: './new-release-page.component.html',
  styleUrls: ['./new-release-page.component.scss'],
})
export class NewReleasePageComponent implements OnInit {
  public signupTrigger: EventEmitter<void> = new EventEmitter<void>();
  public customSignUpTrigger: EventEmitter<string> = new EventEmitter<string>();
  public showAllSeries: boolean = false;
  public showInlineImage: boolean = false;
  public colourBannerMap: {
    year: string;
    colour: string;
    desktopImage: string;
    mobileImage: string;
    resultImage: string;
    term?: string,
    resultPlate: string;
    result: NewReleaseResult;
    bannedList?: string[];
    backgroundPosition?: string;
  }[] = [
    {
      year: '51',
      colour: '#447E96',
      desktopImage: 'DESIGNS_Z4',
      mobileImage: 'DESIGNS_Z4',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '02',
      colour: '#447E96',
      desktopImage: 'GEORGES_CGT',
      mobileImage: 'GEORGES_CGT',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '52',
      colour: '#447E96',
      desktopImage: 'RUSRELL_RS3',
      mobileImage: 'RUSRELL_RS3',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '03',
      colour: '#447E96',
      desktopImage: 'WHOEVER_CYBERTRUCK',
      mobileImage: 'WHOEVER_CYBERTRUCK',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '53',
      colour: '#447E96',
      desktopImage: 'ARSENAL_ALPINE',
      mobileImage: 'ARSENAL_ALPINE',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '04',
      colour: '#447E96',
      desktopImage: 'SLOANES_BENTLEY',
      mobileImage: 'SLOANES_BENTLEY',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '54',
      colour: '#447E96',
      desktopImage: 'LASANGE_FERRARI',
      mobileImage: 'LASANGE_FERRARI',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '05',
      colour: '#447E96',
      desktopImage: 'GHOSTED_BMW',
      mobileImage: 'GHOSTED_BMW',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '55',
      colour: '#447E96',
      desktopImage: 'MASSAGE_FIAT500',
      mobileImage: 'MASSAGE_FIAT500',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '06',
      colour: '#447E96',
      desktopImage: 'HASGAME_URUS',
      mobileImage: 'HASGAME_URUS',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '56',
      colour: '#447E96',
      desktopImage: 'BLOGGER_MINI',
      mobileImage: 'BLOGGER_MINI',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '07',
      colour: '#447E96',
      desktopImage: 'SHOTGUN_DEFENDER',
      mobileImage: 'SHOTGUN_DEFENDER',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '57',
      colour: '#447E96',
      desktopImage: 'FASTEST_LAFERRARI',
      mobileImage: 'FASTEST_LAFERRARI',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '08',
      colour: '#447E96',
      desktopImage: 'PROBLEM_6X6',
      mobileImage: 'PROBLEM_6X6',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '58',
      colour: '#447E96',
      desktopImage: 'HUSBAND_I8',
      mobileImage: 'HUSBAND_I8',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '09',
      colour: '#447E96',
      desktopImage: 'VLOGGER_DEFENDER',
      mobileImage: 'VLOGGER_DEFENDER',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '59',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '10',
      colour: '#447E96',
      desktopImage: 'BELOVED_R8',
      mobileImage: 'BELOVED_R8',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '60',
      colour: '#447E96',
      desktopImage: 'UNGODLY_AMG',
      mobileImage: 'UNGODLY_AMG',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '11',
      colour: '#447E96',
      desktopImage: 'BALLERS_URUS',
      mobileImage: 'BALLERS_URUS',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '61',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '12',
      colour: '#447E96',
      desktopImage: 'EMIRATE_ROLLS',
      mobileImage: 'EMIRATE_ROLLS',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '62',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '13',
      colour: '#447E96',
      desktopImage: 'FRIENDS_MINI',
      mobileImage: 'FRIENDS_MINI',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '63',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '14',
      colour: '#447E96',
      desktopImage: 'GELATOS_FIAT500',
      mobileImage: 'GELATOS_FIAT500',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '64',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '15',
      colour: '#447E96',
      desktopImage: 'BRISTOL_I8',
      mobileImage: 'BRISTOL_I8',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '65',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '16',
      colour: '#447E96',
      desktopImage: 'FLIGHTS_PORSCHE',
      mobileImage: 'FLIGHTS_PORSCHE',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '66',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '17',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '67',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '18',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '68',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '19',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '69',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '70',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '71',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '22',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '72',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '23',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '73',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage: null,
      resultPlate: null,
      result: null,
    },
    {
      year: '24',
      colour: '#447E96',
      desktopImage: 'CURATED_MURCI',
      mobileImage: 'CURATED_MURCI_MB',
      resultImage:
        'https://cdn.platex.co.uk/pages/new-release/24-assets/RESULT_ENRAGED_PISTA.png',
      resultPlate: 'EN24GED',
      result: null,
    },
    {
      year: '74',
      colour: '#265243',
      desktopImage: 'ATTACKS_P1',
      mobileImage: 'ATTACKS_P1_MB',
      resultImage:
        'https://cdn.platex.co.uk/pages/new-release/24-assets/RESULT_MUTANTS_CYBER.png',
      resultPlate: 'MU74NTS',
      result: null,
    },
    {
      year: '25',
      colour: '#363F45',
      desktopImage: 'BERSERK_AMG',
      mobileImage: 'BERSERK_AMG_MB',
      resultImage:
        'https://cdn.platex.co.uk/pages/new-release/24-assets/RESULT_MUTANTS_CYBER.png',
      resultPlate: 'BE25ERK',
      term: 'BERSERK',
      result: null,
    },
    {
      year: '26',
      colour: '#363F45',
      desktopImage: 'LA26EST_AMG',
      mobileImage: 'LA26EST_AMG_MB',
      resultImage:
        'https://cdn.platex.co.uk/pages/new-release/24-assets/RESULT_MUTANTS_CYBER.png',
      resultPlate: 'LA26EST',
      backgroundPosition: 'center center',
      result: null,
      bannedList: [
        "*B26OMB","*C26ASH","*G26HAD","AA26LAH","AA26NAL","AA26NUS","AA26ORT","AA26RSE","AA26RYN","AA26USE","AA26YAN","AA26YPO","AF26NNY","AJ26HAD","AN26NAL","AN26NUS","AS26BOY","AS26FKU","AS26FUL","AS26FWC","AS26GAY","AS26HLE","AS26HOL","AS26OLE","AU26WTZ","AW26NKR","BA26AYS","BA26AYY","BA26AZA","BA26OMB","BJ26AGG","BJ26AGS","BJ26AGZ","BJ26ALL","BJ26ALS","BJ26ALZ","BJ26AYE","BJ26AYO","BJ26AYS","BJ26AYX","BJ26AYY","BJ26AYZ","BJ26OYO","BJ26OYS","BJ26OYX","BJ26OYY","BJ26OYZ","BJ26RLS","BJ26RLY","BJ26RLZ","BJ26STD","BJ26UYE","BJ26UYS","BJ26UYX","BJ26UYY","BJ26UYZ","BL26CKY","BT26NNY","BU26OMB","BY26RUS","BY26UKR","CA26BOM","CA26OMB","CC26OON","DO26GAR","DO26GER","DO26GGA","DO26GGN","DO26GGR","DO26GNG","DO26GNN","DO26GRR","DO26GYN","DO26NGG","DO26NNG","DO26RRR","EU26GON","EU26OMB","EU26RUS","EU26UKR","FK26ANG","FK26ASH","FK26AZA","FK26BRT","FK26ENT","FK26ODD","FK26ODS","FK26ODX","FK26ODZ","FK26OOK","FK26RUS","FK26UKR","FK26VAJ","FK26YPO","FL26NGE","FO26AZA","FU26ASH","FU26AYS","FU26AZA","FU26FFU","FU26GAY","FU26KED","FU26KER","FU26ODD","FU26ODS","FU26ODX","FU26ODZ","GA26ASA","GA26AYS","GA26AZA","GA26BAD","GA26BOM","GA26CMP","GA26CTY","GA26DED","GA26DTH","GA26DWN","GA26FKT","GA26GAY","GA26GUN","GA26HAM","GA26HER","GA26HTR","GA26KLL","GA26KLR","GA26KLS","GA26MOB","GA26NAZ","GA26OFF","GA26OMB","GA26OUT","GA26PLO","GA26ROT","GA26SHT","GA26WAR","GB26ANG","GB26RUS","GB26UKR","GG26NJA","GO26ACK","GO26AZA","GO26BCK","GO26BOM","GO26FWC","GO26HEL","GO26HLL","GO26JEU","GO26OMB","GO26RUS","GO26SHT","GO26UKR","GO26WAR","GY26PDD","GY26PED","HA26AZA","HE26ASH","HE26OLA","HE26SHE","HE26ULA","HH26ASD","HH26OMB","HH26OMO","HH26WAR","JE26HAD","JJ26HAD","JU26ANG","JU26CMP","JU26NAS","JU26NAZ","JU26OVN","LA26EBJ","LA26EFU","LE26AYS","LE26BOO","LE26BOS","LE26BOX","LE26BOZ","LE26ERZ","LE26ZAA","LE26ZAR","LE26ZAS","LE26ZAX","LE26ZAY","LE26ZAZ","LE26ZBO","LE26ZER","LE26ZRR","LE26ZRS","LE26ZZA","LE26ZZR","MO26AZA","MP26OMB","MU26GDD","MU26GED","MU26GER","MU26GGD","MU26GGR","MU26GRR","MU26HER","MY26ANJ","MY26ASH","NA26ASA","NA26ASD","NA26ASU","NA26ASX","NA26AYS","NA26TZY","NO26ALS","NO26AYS","NO26AZA","NO26COP","NO26FUZ","NO26LAC","NO26LAK","NO26LCK","NO26LEZ","NO26ODD","NO26ODS","NO26ODX","NO26ODZ","NO26OOK","NO26RUS","NO26UKR","NO26YPO","NY26NOG","OK26AGX","OK26GAG","ON26ERS","ON26ERZ","OR26GYS","OR26GYX","OR26GYY","OR26GYZ","OR26YBJ","OR26YES","OR26YEZ","OR26YFK","OR26YHO","OR26YSS","OR26YSX","OR26YSZ","OR26YXX","OR26YYS","OR26YYX","OR26YYY","OR26YYZ","OR26YZZ","PM26OMB","PU26SAY","PU26SEY","PU26SYS","PU26SYY","RA26EAD","RA26EDD","RA26HED","RR26PED","RR26PER","RR26PES","RR26PEU","RR26PEX","RR26PEY","RU26OMB","RU26RUS","RU26UKR","SC26TUM","SH26GED","SH26GER","SH26GGD","SH26GGS","SH26GGZ","SH26HAG","SK26NKK","SK26NKS","SK26NKY","SK26NKZ","SK26NNK","SL26GGS","SL26GGY","SL26GGZ","SL26GSS","SL26GZZ","SP26STC","SP26STK","SP26ZES","SP26ZZY","SP26ZZZ","SS26ANG","SS26MBO","ST26ABB","ST26ABS","TE26ROR","TO26AZA","TU26NOB","TW26TTS","UA26USE","UA26YAN","UF26GGY","UG26OOK","UK26ANG","UK26AZA","UK26OMB","UK26ONE","UK26RUS","UK26UKR","UN26ERS","UN26ERZ","UN26RUS","UN26UKR","UP26AZA","UP26BOM","UP26RUS","UP26UKR","UR26AYS","UR26AYX","UR26AYY","UR26AYZ","US26AZA","US26MBO","US26OMB","US26WAR","UT26NNS","UT26NNY","UT26NNZ","UT26NSX","UW26NKR","WA26ANG","WA26ASA","WA26ASD","WA26AYS","WA26AZA","WA26GBR","WA26OMB","WA26OOK","WA26RAB","WA26RUS","WA26UKR","WO26OUT","WO26SGO","WO26SNO","WW26ASD","WW26ASX","WW26GAS","WW26JEU","WW26JUU","WW26NAZ","WW26NKR","WW26NKS","WW26NKZ","WW26RUS","XG26NJA","XN26ERS","XN26ERZ","XT26NNY","YA26DEE","YA26DYS","YA26DYY","YE26MEN","YE26RUS","YE26UKR"
      ].sort()
    },
    {
      year: '75',
      colour: '#483b32',//'#d9a320',
      desktopImage: 'HOTSHOT_URUS',
      mobileImage: 'HOTSHOT_URUS_MB',
      resultImage:
        'https://cdn.platex.co.uk/pages/new-release/HOTSHOT_URUS.png',
      resultPlate: 'GO75HOT',
      term: 'GOTSHOT',
      result: null,
      bannedList: [
        "**75 HAG","EA75 DKS","GA75 YOU","HO75 EXE","PE75 MUF","**75 LAG","EA75 DYK","GA75 ZAA","HO75 EXX","PE75 NOB","**75 PAZ","EA75 FWF","GA75 ZAX","HO75 FKS","PE75 RVT","**75 TAB","EA75 GAL","GB75 BAD","HO75 FWC","PE75 VRT","AA75 LAH","EA75 GAY","GB75 BOM","HO75 FWF","PM75 HOT","AA75 RSE","EA75 GRL","GB75 DED","HO75 UCA","PP75 OFF","AF75 GAT","EA75 HER","GB75 DWN","HO75 UCC","PP75 SED","AF75 GTT","EA75 HTT","GB75 FKT","HO75 UCX","PP75 SER","AF75 GUT","EA75 JUW","GB75 GNG","HO75 UKK","PP75 SSS","AH75 OMO","EA75 LAD","GB75 GUN","HO75 VAG","PP75 SUP","AJ75 HAD","EA75 LEZ","GB75 HTR","HO75 VAJ","PR75 CCK","AP75 OFF","EA75 LSD","GB75 KLL","JJ75 HAD","PR75 CKK","AP75 SUP","EA75 MAM","GB75 KLR","JU75 CMP","PR75 CKS","AR75 RSE","EA75 MEE","GB75 KLS","JU75 NAS","PS75 CHO","AR75 YAN","EA75 MEN","GB75 MOB","JU75 NAZ","PU75 SYY","AS75 BJX","EA75 MLF","GB75 SHT","JU75 OVN","RE75 ARD","AS75 EXX","EA75 MME","GB75 WAR","KL75 HOT","RE75 TRD","AS75 FKT","EA75 MOT","GE75 BJS","KL75 REL","RO75 NOB","AS75 FUL","EA75 MUF","GE75 BJX","KN75 FED","RO75 STD","AS75 FWC","EA75 MUM","GE75 BJZ","KN75 FER","RO75 VAG","AS75 GAY","EA75 NAN","GE75 BOM","KN75 FES","RO75 VAJ","AS75 HAT","EA75 NOB","GE75 DCK","KN75 FEU","SH75 HOT","AS75 HOL","EA75 POO","GE75 DED","KN75 FEX","SH75 TSS","AS75 JOY","EA75 PWP","GE75 FKT","KN75 FEY","SH75 TTR","AS75 LWT","EA75 SHT","GE75 FWC","KN75 VED","SH75 TTS","AS75 OLE","EA75 VAG","GE75 GAY","KN75 VES","SH75 TTT","AS75 RUB","EA75 VAJ","GE75 GUN","KN75 VEU","SH75 TTY","AS75 WNK","EU75 BAD","GE75 HOT","LE75 BJX","ST75 ABB","AU75 WTS","EU75 BOM","GE75 JEU","LE75 BOS","ST75 ABS","AU75 WTZ","EU75 FWC","GE75 JUW","LE75 BOZ","ST75 ABU","BA75 ARD","EU75 GON","GE75 KYK","LE75 KLL","ST75 ABX","BA75 ERD","EU75 HTR","GE75 LEZ","LE75 LSD","ST75 ABZ","BA75 HTT","EU75 ODS","GE75 LGB","LE75 SHT","SU75 CDE","BA75 SHT","EU75 ODZ","GE75 LSD","LE75 ZAA","TH75 SHT","BA75 TAD","EU75 OFF","GE75 NGR","LE75 ZAR","TO75 DCK","BA75 TRD","EU75 OUT","GE75 NGZ","LE75 ZAS","TO75 DED","BA75 TTD","EU75 SHT","GE75 PAK","LE75 ZAX","TO75 DKS","BA75 TUD","EU75 WAR","GE75 PKY","LE75 ZAZ","TO75 DTH","BF75 TED","EU75 YES","GE75 PUS","LE75 ZBO","TO75 DYK","BJ75 BAD","FA75 DCK","GE75 STD","LE75 ZER","TO75 GAY","BJ75 EXX","FA75 DKS","GE75 VAG","LE75 ZRR","TO75 HOT","BJ75 EXY","FA75 DYC","GE75 VAJ","LE75 ZRS","TO75 NOB","BJ75 GUD","FA75 DYK","GO75 BLO","LE75 ZZA","TO75 PRC","BJ75 HAT","FA75 EXX","GO75 BOM","LE75 ZZR","TO75 PRK","BJ75 HOT","FA75 FKT","GO75 FKT","LO75 DED","TO75 VAG","BJ75 LOB","FA75 FWF","GO75 FWF","MO75 EST","TO75 VAJ","BJ75 LSD","FA75 GAT","GO75 GAY","MP75 GUN","TO7S DYE","BJ75 NOB","FA75 GTS","GO75 GUN","MP75 HOT","TO7S FKT","BJ75 STD","FA75 GTT","GO75 HOT","MU75 DER","TO7S KLL","BO75 DED","FA75 GUT","GO75 JEU","NA75 TZE","TO7S LSD","BO75 DTH","FA75 NOB","GO75 JUW","NA75 ZEE","TO7S MDR","BO75 GAY","FA75 PRC","GO75 KLR","NA75 ZZE","TR75 DRG","BO75 LSD","FA75 PRK","GO75 KLS","NF75 NAZ","TR75 LSD","BO75 NOB","FA75 PUS","GO75 KYK","NF75 XRW","TR75 MAC","BU75 DCK","FA75 RSE","GO75 LEZ","NG75 NOG","TR75 MAK","BU75 DKS","FA75 SHT","GO75 LSD","NO75 ANE","TR75 POT","BU75 EXE","FA75 VAG","GO75 NGR","NO75 LAM","TT75 RUB","BU75 EXS","FA75 VAJ","GO75 NGZ","NO75 LEZ","TT75 WNK","BU75 EXX","FA75 WAH","GO75 PAK","NO75 REL","UA75 RSE","BU75 EXZ","FF75 TED","GO75 PKY","NU75 ACK","UB75 TCH","BU75 FKT","FK75 AKE","GO75 REL","NU75 BJS","UF75 TED","BU75 GAY","FK75 EXE","GO75 SHT","NU75 BJX","UP75 LAM","BU75 HTE","FK75 EXX","GO75 STD","NU75 BJZ","UP75 LSD","BU75 LSD","FK75 EXY","GO75 VAG","NU75 DCK","UP75 REL","BU75 NOB","FK75 HAT","GO75 VAJ","NU75 FKT","UP75 SED","BU75 SHT","FK75 LAM","GO75 WAR","NU75 FUL","US75 HAT","CO75 DED","FK75 LOB","GU75 BOM","NU75 JOB","US75 WAR","CO75 DTH","FK75 REL","GU75 DED","NU75 NOB","UU75 HAT","CR75 PLE","FK75 VAJ","GU75 DKS","NU75 RUB","VA75 GNA","CR75 PPL","GA75 AJU","GU75 DTH","NU75 SAC","WE75 BJS","CU75 DCK","GA75 BOM","GU75 FKT","NU75 SAK","WE75 BJX","CU75 DKS","GA75 BOY","GU75 FWC","NU75 STD","WE75 BJZ","CU75 DYK","GA75 CMP","GU75 HAT","NU75 UCZ","WE75 EXX","CU75 FGM","GA75 DED","GU75 WAR","NU75 UKK","WE75 FWF","CU75 FWF","GA75 DTH","GY75 POS","NU75 UKS","WE75 MUF","CU75 GAY","GA75 GAY","HE75 HEE","NU75 UKZ","WE75 NOB","CU75 MUF","GA75 HER","HE75 HES","NU75 VAG","WE75 POT","CU75 NOB","GA75 JEU","HE75 HEX","NU75 VAJ","WE75 PRC","CU75 PRC","GA75 JUD","HE75 HEZ","OR75 ASM","WE75 PRK","CU75 PRK","GA75 KLL","HH75 NAZ","PA75 NOB","WE75 PUS","CU75 VAG","GA75 NAS","HH75 OMO","PA75 PUS","WE75 VAG","CU75 VAJ","GA75 NAZ","HH75 TLR","PA75 VAG","WE75 VAJ","CU75 YOU","GA75 OVN","HO75 AGE","PA75 VAJ","WO75 FKT","DA75 FKT","GA75 SED","HO75 BJS","PE75 ADO","XA75 RSE","EA75 BOY","GA75 SSD","HO75 BJX","PE75 DCK","XF75 TED","EA75 BUT","GA75 UUU","HO75 BJZ","PE75 KLL","YB75 TCH","EA75 DCK","GA75 UUX","HO75 DCK","PE75 KLR","YE75 MEN"
      ].sort()
    },
    {
      year: '76',
      colour: '#363F45',
      desktopImage: 'HEMI_76',
      mobileImage: 'HEMI_76_MB',
      resultImage:
        'https://cdn.platex.co.uk/pages/new-release/24-assets/RESULT_MUTANTS_CYBER.png',
      resultPlate: 'GO76AME',
      term: 'GOTGAME',
      result: null,
      bannedList: [
        "AA76 LAH","AA76 RSE","AA76 RYN","AA76 YAN","AC76 AZA","AC76 HAD","AD76 RKY","AF76 GAT","AF76 GGY","AF76 GUT","AF76 OTT","AG76 HAD","AJ76 HAD","AR76 RSE","AS76 ABY","AS76 AST","AS76 BOY","AS76 FKT","AS76 FKU","AS76 FWC","AT76 CKU","AT76 KMP","AT76 KPM","AT76 KUU","AU76 WTZ","AW76 NKR","BJ76 AG*","BJ76 ALL","BJ76 ALS","BJ76 ALZ","BJ76 AY*","BJ76 HOT","BJ76 LOW","BJ76 ONK","BJ76 OOB","BJ76 OYO","BJ76 OYS","BJ76 OYX","BJ76 OYY","BJ76 OYZ","BJ76 RLS","BJ76 RLY","BJ76 RLZ","BJ76 STD","BJ76 STY","BJ76 UNK","BJ76 USH","BJ76 UYE","BJ76 UYS","BJ76 UYX","BJ76 UYY","BJ76 UYZ","BL76 CKY","BU76 AYS","BU76 AYX","BU76 AYY","BU76 AYZ","BU76 DCK","BU76 DKS","BU76 GAY","BU76 MUF","BU76 NOB","BU76 ONK","BU76 OYS","BU76 OYX","BU76 OYY","BU76 SHT","BU76 UNK","BU76 USH","BU76 VAJ","BY76 RUS","BY76 UKR","CC76 OON","CO76 ASH","CU76 ASH","CU76 AYS","CU76 AYX","CU76 AYY","CU76 AZA","CU76 FGM","CU76 HER","CU76 JAP","CU76 JUW","CU76 LEZ","CU76 MPX","CU76 MUF","CU76 NGR","CU76 NOB","CU76 PAK","CU76 PKY","CU76 VAG","CU76 VAJ","DD76 RKY","EA76 ASH","EA76 BUT","EA76 COX","EA76 DCK","EA76 DKS","EA76 DYK","EA76 FWF","EA76 JUW","EA76 LEZ","EA76 LSD","EA76 MUF","EA76 NOB","EA76 OOB","EA76 POO","EA76 PWP","EA76 SHT","EA76 VAG","EA76 VAJ","EU76 GON","EU76 OMB","EU76 ONE","EU76 RMY","EU76 RUS","EU76 UKR","FA76 ASH","FA76 ATS","FA76 ATT","FA76 ATZ","FA76 GGY","FA76 HAG","FA76 JUW","FA76 NOB","FA76 OTE","FA76 OTS","FA76 OTT","FA76 OTX","FA76 OTZ","FA76 VAG","FA76 VAJ","FA76 WAH","FA76 YPS","FA76 YPX","FF76 GAT","FK76 ABY","FK76 ASH","FK76 AZA","FK76 ENT","FK76 FWF","FK76 HAD","FK76 MUF","FK76 NUS","FK76 ODS","FK76 ODX","FK76 ODZ","FK76 OMB","FK76 OVT","FK76 OVV","FK76 RUS","FK76 UKR","FK76 VAJ","FL76 NGE","FR76 VAG","FR76 VAJ","GA76 AJU","GB76 AZA","GB76 HAD","GB76 RUS","GB76 UKR","GE76 AJU","GE76 ASH","GE76 AYS","GE76 AYX","GE76 AYY","GE76 AYZ","GE76 AZA","GE76 BJS","GE76 BJX","GE76 BJZ","GE76 BOM","GE76 GUN","GE76 JEU","GE76 JUW","GE76 KYK","GE76 LEZ","GE76 LOW","GE76 LSD","GE76 MPS","GE76 MPX","GE76 MPZ","GE76 NGR","GE76 NGZ","GE76 NOG","GE76 OGS","GE76 OGZ","GE76 OMB","GE76 ONG","GE76 PAK","GE76 PKY","GE76 PUS","GE76 RUS","GE76 STD","GE76 VAG","GE76 VAJ","GG76 HAD","GO76 ASH","GO76 AZA","GO76 BOM","GO76 FKT","GO76 FWC","GO76 HAD","GO76 JEU","GO76 JUW","GO76 KYK","GO76 LSD","GO76 NGR","GO76 NGZ","GO76 OGS","GO76 OGZ","GO76 OMB","GO76 PAK","GO76 PKY","GO76 RUS","GO76 SHT","GO76 STD","GO76 UKR","GO76 VAG","GO76 VAJ","GO76 WAR","GU76 AJU","GU76 AY*","GU76 AZA","GU76 FWC","GU76 GAY","GU76 JEU","GU76 JUW","GU76 KYK","GU76 LEZ","GU76 MPS","GU76 MPX","GU76 MPZ","GU76 NGR","GU76 NGZ","GU76 NOG","GU76 PAK","GU76 PKY","GU76 VAG","GU76 VAJ","GY76 PED","HE76 OLA","HE76 ULA","HH76 ASD","HH76 MAS","HH76 NAZ","HH76 OMB","HH76 OMO","HH76 TED","HH76 TES","HH76 TLR","HH76 WAR","HO76 ASH","HO76 BJS","HO76 BJX","HO76 BJZ","HO76 COX","HO76 CST","HO76 VAG","HO76 VAJ","JE76 HAD","JG76 HAD","JJ76 HAD","JU76 AGD","JU76 CMP","JU76 NAS","JU76 NAZ","JU76 OMB","JU76 OVN","LE76 ZAA","LE76 ZAR","LE76 ZAS","LE76 ZAX","LE76 ZAY","LE76 ZAZ","LE76 ZBO","LE76 ZER","LE76 ZRR","LE76 ZRS","LE76 ZZA","LE76 ZZR","MP76 GUN","MP76 KLR","MP76 OMB","MP76 UNN","MP76 UNS","MP76 UNX","MP76 UNZ","MR76 ANJ","MR76 ONG","NA76 TZY","NA76 ZEE","NA76 ZZE","NE76 NOG","NE76 RO*","NE76 RRO","NO76 AY*","NO76 AZA","NO76 LAC","NO76 LAK","NO76 LEZ","NO76 OG*","NO76 RUS","NO76 UKR","NU76 JOB","NU76 RAB","NU76 SAC","NU76 SAK","NU76 STD","NU76 VAG","NU76 VAJ","NY76 NOG","OF76 GAT","OF76 OTS","OF76 OTT","OR76 GYS","OR76 GYX","OR76 GYY","OR76 GYZ","OR76 YBJ","OR76 YES","OR76 YEZ","OR76 YFK","OR76 YHO","OR76 YSS","OR76 YSX","OR76 YSZ","OR76 YXX","OR76 YYS","OR76 YYX","OR76 YYY","OR76 YYZ","OR76 YZZ","OU76 AZA","OU76 LAK","OU76 RUS","OU76 UKR","OW76 NKR","PA76 VAG","PA76 VAJ","PE76 MUF","PE76 NOB","PE76 VAG","PE76 VAJ","PM76 GUN","PM76 KLR","PM76 OMB","PM76 UNN","PM76 UNS","PM76 UNX","PM76 UNZ","PS76 CHO","PU76 OMB","RA76 AZA","RA76 HED","RE76 ARD","RE76 RDD","RE76 RDS","RE76 RDU","RE76 RDX","RE76 RDZ","RE76 RRD","RE76 TAD","RE76 TRD","RO76 AZA","RO76 HAD","RO76 VAG","RO76 VAJ","RR76 PED","RR76 PER","RR76 PES","RR76 PEU","RR76 PEX","RR76 PEY","RU76 RUS","RU76 UKR","SE76 OMB","SH76 AGS","SH76 AGZ","SH76 ATZ","SH76 GED","SH76 GGD","SH76 GGS","SH76 GGZ","SH76 HAG","SH76 TTY","SK76 NKK","SK76 NKS","SK76 NKY","SK76 NKZ","SK76 NNK","SL76 GG*","SL76 GSS","SL76 GSX","SL76 GZX","SL76 GZZ","SL76 UTS","SP76 SSS","SP76 STC","SP76 ZEE","SP76 ZES","SP76 ZYY","SP76 ZZY","SP76 ZZZ","SS76 ABS","SS76 ABZ","SS76 AGU","SS76 ASD","SS76 BBB","SS76 BBS","SS76 BBY","SS76 BED","SS76 BSS","SS76 BZZ","SS76 ERM","SS76 MBO","ST76 ABB","ST76 ABS","ST76 ABU","ST76 ABX","ST76 ABZ","ST76 BBB","ST76 BBD","ST76 BBS","ST76 BBY","ST76 BBZ","ST76 BED","ST76 BER","ST76 BES","ST76 BSS","ST76 BUU","SU76 CDE","TA76 BAN","TO76 ASH","TO76 RAB","TR76 ANY","TR76 NNY","TU76 VAG","TU76 VAJ","UA76 RSE","UD76 RKY","UF76 GAT","UF76 GGY","UF76 GGZ","UF76 GSS","UF76 GTT","UF76 GTZ","UF76 GUT","UF76 OTS","UF76 OTT","UF76 OTZ","UK76 AZA","UK76 HAD","UK76 OMB","UK76 ONE","UK76 RUS","UK76 UKR","UN76 OMB","UN76 RRZ","UN76 RUS","UN76 UKR","UP76 AZA","UP76 RSE","UP76 RUS","UP76 UKR","UP76 WAR","UR76 AY*","UR76 WAT","US76 AZA","US76 OMB","US76 RUS","US76 UKR","US76 WAR","UW76 NKR","VA76 GNA","VD76 AY*","VO76 RUS","VO76 UKR","WA76 RUS","WA76 UKR","WE76 ASH","WE76 BJS","WE76 BJX","WE76 BJZ","WE76 BUT","WE76 COX","WE76 DYK","WE76 FWF","WE76 MUF","WE76 NOB","WE76 ONK","WE76 OOB","WE76 PRC","WE76 PRK","WE76 PUS","WE76 VAG","WE76 VAJ","WE76 XBJ","WO76 BLK","WO76 VAG","WO76 VAJ","WW76 NKR","WW76 NKZ","XG76 HAD","XH76 MAS","XJ76 HAD","XS76 ABU","XW76 NKR","YE76 AZA","YE76 MEN","YE76 RUS","YE76 UKR","YW76 NKR","**76 OOK","**76 YPO","*F76 GOT","*N76 ERR","*N76 ERS","*N76 ERZ","*N76 GAA","*N76 NOG","*T76 NNY","*W76 NKS"
      ].sort()
    },
  ];

  public resultMapMatris: {
    width: number;
    prev: number;
    before: number;
    during: number;
  }[] = [
    {width: 1255, prev: 100000, before: 4, during: 4},
    {width: 1254, prev: 10000, before: 3, during: 2},
    {width: 1008, prev: 1254, before: 3, during: 2},
    {width: 1000, prev: 1008, before: 4, during: 0},
    {width: 903, prev: 1000, before: 3, during: 2},
    {width: 768, prev: 903, before: 3, during: 2},
    {width: 723, prev: 768, before: 2, during: 0},
    {width: 546, prev: 723, before: 3, during: 0},
    {width: 0, prev: 723, before: 2, during: 0},
  ];

  public releaseYear: string;
  public releaseMonth: string;
  public DVLAreleaseMonth: string;
  public breadcrumbRelease: string;
  public saving: boolean = false;
  public notifiying: boolean = false;
  public currentAlphabet = 'A';
  public currentTermAlphabet = 'A';
  public alphabet: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  public stickyLinkConfig: StickyConfig;
  public years_stickyLinkConfig: StickyConfig;
  public rsFeatured = new FeatureType('Recently Sold', 'recently-sold');

  public byoLoading: boolean = false;
  public byoResults: SearchReqResponse;
  public byoResultChange: EventEmitter<SearchReqResponse> =
    new EventEmitter<SearchReqResponse>();

  public future_faq: InfoDropdown[] = GlobalFaqs.GetFaqsByKey("New Release");

  public faq: InfoDropdown[] = [
    FaqBuilder.build('faq_1', `When will the DVLA release the new '25' Series Registrations?`, [`The Driver and Vehicle Licensing Agency (DVLA) released the '25' series registrations in March 2025. This release introduced nearly 8 million new vehicle registration numbers into circulation, providing an extensive range of private number plates for buyers.`]),
    FaqBuilder.build('faq_2', `What does the '25' relate to in the registration?`, [`In the UK vehicle registration system, the '25' serves as the age identifier in the standard format: two letters (indicating the area code), two numbers (the age identifier), and three random letters. The '25' identifies vehicles registered between March and August 2025.`]),
    FaqBuilder.build('faq_3', `How does the number 25 relate to 2025?`, [`The age identifier in UK vehicle registrations changes biannually. For vehicles registered between March and August, the identifier corresponds to the last two digits of the year ('25' for 2025). For registrations issued from September onwards, the age identifier changes to the year plus 50 (e.g., '75' for September 2025 onwards). This system makes it easy to identify when a vehicle was registered.`]),
    FaqBuilder.build('faq_4', `Are all '25' registrations seven characters long?`, [`Yes, all '25' series registrations consist of seven characters, following the current format introduced in September 2001. This format includes two letters (area code), two numbers (age identifier), and three random letters, distinguishing it from older formats like prefix, suffix, and dateless registrations.`]),
    FaqBuilder.build('faq_5', `How much will '25' Private Registrations cost?`, [`The cost of '25' private registrations typically ranges from £399 to £3,999, depending on the desirability and uniqueness of the combination. The DVLA may reserve highly sought-after plates, such as those featuring popular names or words, for auction. However, many excellent plates are available at fixed prices.`]),
    FaqBuilder.build('faq_6', `Is it true that the DVLA holds back all the good plates to go to auction?`, [`The DVLA does reserve certain registrations for auction, particularly those anticipated to attract significant interest and higher bids. However, identifying these valuable combinations among nearly 8 million new registrations per release is a considerable task. Examples of '74' registrations held back for auction include:`, ``, `These selections demonstrate the DVLA's strategy to auction registrations with potential for higher value due to their distinctive combinations.`, `</p><ul><li>OC74 NES</li><li>NA74 LYA</li><li>NA74 SHA</li><li>NO74 BLE</li><li>OC74 GON</li><li>GE74 WAY</li><li>MA74 DOR</li></ul><p>`, `These selections demonstrate the DVLA's strategy to auction registrations with potential for higher value due to their distinctive combinations.`]),
    FaqBuilder.build('faq_7', `Will there be any potentially valuable word plates available in the fixed-price general release?`, [
      `Yes, absolutely! At PlateX, we use our advanced search algorithm to identify valuable word plates that might otherwise be overlooked. Our findings include numerous one- and two-word plates from the Current '25' series, all of which are showcased on our <a href="/new-release/25">New Release - 25 Reg</a> page for easy access.`,
      `While the DVLA does hold back many notable word plates for auction, some valuable combinations still slip through to general release. For instance, the plate <a href="/plate-detail/KN19HTS">KN19 HTS</a> was sold during general release for only £399, while its sister plate, <a href="/plate-detail/KN16HTS">KN16 HTS</a>, was reserved for auction and fetched an impressive £36,802—nearly 100 times more!`,
      `To ensure you don’t miss out, registered users on PlateX gain exclusive access to potential word plate combinations weeks ahead of the general release.`
    ]),
    FaqBuilder.build('faq_8', `Where can I view the upcoming “75” registration`, [
      `You can see all the word plate results first on our <a href="/new-release/75">Future 25 Registration</a>`
    ]),
    FaqBuilder.build('faq_9', `I cannot access the Future 75 Registration page`, [
      `Access to view potential new word registrations on the <a href="/new-release/75">Future 75 Registration</a> page is exclusively available to logged-in users. This ensures that our registered users gain early and exclusive access to potential word plate combinations uncovered by our advanced search technology.`
    ]),
    FaqBuilder.build('faq_10', `Looking for something more personal?`, [
      `The best way to find a personalised plate for your car is by using our advanced <a href="/buy">Super-Search</a> tool. This powerful feature provides a range of results tailored to your search terms, making it easy to discover private number plates that match your preferences.`,
      `If you're looking for the latest issue plates for your new car, these matches are displayed in the <a href="/buy">Newly listed</a> section of each word searched.`
    ]),
    //     new InfoDropdown('nrp_1', `Can I Buy a New Release Private Number Plate Even If I Don't Have a New Vehicle?`, false, [
    //       new InfoDropdownContent(null, `<p class="lh-sm fs-md-16 fs-mb-16">
    // Yes, you can buy a new release private number plate even if you don't have a new vehicle. Private number plates can be purchased and held on a retention certificate (V778) for up to 10 years, with the option to renew it for another 10 years if needed. This means you can invest in a desirable private number plate from the DVLA's general release at a fixed price and save it for future use or resale. The retention certificate allows you to keep the number plate without assigning it to a vehicle immediately, providing flexibility and making private number plates a great investment option, regardless of whether you currently own a vehicle</p>`)
    //     ]),
    //     new InfoDropdown('nrp_2', `Have the DVLA Banned Any Number Plates from the New Release?`, false, [
    //       new InfoDropdownContent(null, `<p class="lh-sm fs-md-16 fs-mb-16">Yes, the DVLA has banned certain number plates from each new release. Every March and September, the DVLA holds a meeting to identify any permutations of the new digits that could form offensive words or resemble them. This meeting is reportedly one of the more popular ones within the DVLA, as staff creatively identify potentially rude and offensive plates before they are issued to motorists.</p>
    // <p class="lh-sm fs-md-16 fs-mb-16"><a class="link" href="#">Check out the most recent banned plates here.</a></p>
    // <p class="lh-sm fs-md-16 fs-mb-16">Anything related to violence, sex, or discrimination is automatically banned. Plates that slip through the net can also be rescinded at a later date. For example, BA22 ARD was banned when the '22' plate series was released in March 2022. Registrations referring to Covid-19, such as CO22 ONA, were also prohibited.</p>
    // <p class="lh-sm fs-md-16 fs-mb-16">This process ensures that the UK number plate system maintains a standard of decency and respect, preventing offensive or inappropriate messages from appearing on the roads. Investing in private number plates means adhering to these guidelines, ensuring a respectful and acceptable representation on your vehicle.</p>`)
    //     ]),
    //     new InfoDropdown('nrp_4', `Can I Make Money from Investing in New Issue Private Number Plates?`, false, [
    //       new InfoDropdownContent(null, `<p class="lh-sm fs-md-16 fs-mb-16">The short answer is yes!<br />
    //         Our analysis of thousands of private number plate transactions suggests that some of the largest and most predictable returns come from high-quality word and name private registrations first purchased new at a fixed price from the DVLA general release<br />
    //         You can see examples of private plate resales in the Market Insights section.</p>`)
    //     ]),
    //     new InfoDropdown('nrp_5', `What Are the Best Types of New Issue Private Plates to Buy for Investment?`, false, [
    //       new InfoDropdownContent(null, `<p class="lh-sm fs-md-16 fs-mb-16">
    // Our market research shows that new issue private plates that closely resemble popular names or words, tend to be fetch higher resale prices. For instance, the plate RU52ELL resembles the name "Russell" and was bought for £499 in 2002, then resold for £8,040 in 2023, achieving an ROI of 1511%. Another example is PO10CUP, which spells out "Polo Cup," referring to the equestrian sport. This plate was purchased for £499 in 2010 and sold for £5,228 in 2020, yielding a 948% ROI.</p>`)
    //     ]),
    //     new InfoDropdown('nrp_6', `How Does Investing in New Issue Private Number Plates Compare to Traditional Investments?`, false, [
    //       new InfoDropdownContent(null, `<p class="lh-sm fs-md-16 fs-mb-16">
    // While returns vary considerably due to the quality of the new issue registration, the ROI (Return on Investment) for private number plates can be exceptionally high compared to traditional investment options. For example, HE10YOU, bought for £250 in 2010, was resold for £2,700 in 2020, delivering an ROI of 980%. Similarly, NE57EGG, purchased for £399 in 2007, was sold for £3,355 in 2023, yielding an ROI of 741%. In comparison, the FTSE 100 achieved an approximate ROI of 70% from 2010 to 2020, while gold had an ROI of about 50% over the same period. These figures illustrate that with strategic selection and timing, the returns on private number plates can surpass those of stocks, real estate, and other conventional investments, making them a highly attractive investment option.</p>`)
    //     ])
  ];

  public nameReleaseResults: HttpLoadingResp<NewReleaseResult[]> =
    new HttpLoadingResp(true, []);
  public namesFiltered: NewReleaseResult[];
  public termReleaseResults: HttpLoadingResp<NewReleaseResult[]> =
    new HttpLoadingResp(true, []);
  public termsFiltered: NewReleaseResult[];
  public seriesBYO: BYOTermResponse;

  public termSorting: DropdownOption = new DropdownOption('HIGH-TO-LOW', 'Price High to Low');
  public mobileFilterToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  public sortTrigger: EventEmitter<void> = new EventEmitter<void>();
  public filterChange: EventEmitter<SearchFilters> = new EventEmitter<SearchFilters>();
  public filterUpdate: EventEmitter<SidebarFilterConfig<any>> =
    new EventEmitter<SidebarFilterConfig<any>>();
  public sortDropdownConfig: DropdownConfig = new DropdownConfig('Sort By', 'swap_vert', [
      new DropdownOption('A-Z', 'A-Z'),
      new DropdownOption('Z-A', 'Z-A'),
      new DropdownOption('LOW-TO-HIGH', 'Price Low to High'),
      new DropdownOption('HIGH-TO-LOW', 'Price High to Low')
    ],
    {initialValue: new DropdownOption('HIGH-TO-LOW', 'Price High to Low')});
  public searchFilters: SidebarFilterConfig<SearchFilters> = new SidebarFilterConfig<SearchFilters>(
    [
      new SidebarFilterGroup('Sort By', [
        new SidebarFilter('sort', 'Sort By', 'sortBy', {
          selectConfig: this.sortDropdownConfig
        })
      ], {visible: true, customClass: 'd-block d-lg-none'}),
    ], this.filterChange);

  public namePlacement: PagePlacement = PAGE_PLACEMENTS.SUPERCHARGE_YOUR_SEARCH(
    this.quickSignupService,
    PAGE_PLACEMENTS.OWN_SIMILAR_FREE_3_MONTHS()
  );
  public termPlacement: PagePlacement = PAGE_PLACEMENTS.DISCOVER_NAME_PLAGES();
  public actualReleaseYear: string;
  public DVLAReleaseYear: string;

  constructor(
    private router: Router,
    private registrationService: RegistrationService,
    private activatedroute: ActivatedRoute,
    private searchService: SearchService,
    private quickSignupService: QuickSignupService,
    private userService: UserService
  ) {
    const selectedTab = this.activatedroute.snapshot.queryParamMap.get('tab')
    this.releaseYear = this.activatedroute.snapshot.paramMap.get('releaseYear');
    this.actualReleaseYear = this.releaseYear[0].replace('5', '0').replace('6', '1').replace('7', '2') + this.releaseYear[1];
    this.DVLAReleaseYear = (this.releaseYear[0] === '2' && parseInt(this.releaseYear[1]) > 5)
      ? this.releaseYear[0] + (parseInt(this.releaseYear[1]) - 1).toString()
      : this.actualReleaseYear;
    if (this.releaseYear == null) return;
    this.breadcrumbRelease = `${this.releaseYear} Registration Issue`;

    this.filterChange.subscribe((_: SearchFilters) => {
      this.TermSortChange(this.sortDropdownConfig.options.find(o => o.value === _.sortBy), "");
    });

    if (this.releaseYear.startsWith('0') || this.releaseYear.startsWith('5')) {
      this.DVLAreleaseMonth = this.releaseYear.startsWith('0')
        ? 'November'
        : 'May';
      this.releaseMonth = this.releaseYear.startsWith('0')
        ? 'March'
        : 'September';
    } else {
      this.DVLAreleaseMonth = this.releaseYear.startsWith('2')
        ? 'November'
        : 'May';
      this.releaseMonth = this.releaseYear.startsWith('2')
        ? 'March'
        : 'September';
    }

    this.years_stickyLinkConfig = new StickyConfig(
      [
        new StickyLinkGroup(this.colourBannerMap.map(year => {
          return new StickyLink(`${year.year} Release`, `new-release/${year.year}`, year.year == this.releaseYear, StickyLinkType.OUT_OF_PAGE);
        }).filter(x => x != null)),
      ],
      new EventEmitter<void>(),
      THICKER_SELECTED_BORDER
    );

    this.stickyLinkConfig = new StickyConfig(
      [
        new StickyLinkGroup([
          // new StickyLink('Two Words', 'search', true),
          new StickyLink('Perfect Plates', 'terms', false),
          this.isFutureRelease() ? null : new StickyLink(`Build-Your-${this.releaseYear}`, 'byo', false),
          new StickyLink('Name', 'names', false),
          this.hasBannedPlates() ? new StickyLink('Banned Plates', 'banned', false) : null,
          // new StickyLink('Market Insights', 'market-information', false),
          new StickyLink('Q&As', 'faq', false),
        ].filter(x => x != null)),
      ],
      new EventEmitter<void>(),
      GOOGLE_REDUCED_CHIPS
    );

    this.seriesBYO = new BYOTermResponse().construct();
    this.seriesBYO.current.construct(
      'current',
      '',
      this.releaseYear.toString(),
      ''
    );

    // calc current date and determine future/current
  }

  public byoUpdated(res: { prefix: boolean, value: string }): void {
    console.log(res);
    this.seriesBYO = null
    setTimeout(() => {
      this.seriesBYO = new BYOTermResponse().construct();
      this.seriesBYO.current.construct(
        'current',
        res.prefix ? res.value.substring(0, 2) : '',
        this.releaseYear.toString(),
        res.prefix ? '' : res.value.slice(-3),
      );
    }, 200);
  }

  public handleByoResultChange(res: { loading: boolean,  results: SearchReqResponse}): void {
    this.byoLoading = res.loading;
    this.byoResults = res.results;
    this.byoResultChange.emit(res.results);
  }

  ngOnInit(): void {
    setTimeout(() => {
      var indexToScroll = this.colourBannerMap.findIndex(
        (y) => y.year === this.releaseYear
      );
      if (indexToScroll === -1) return;
      const el = document.getElementById(`release-year-${this.releaseYear}`)
      if (el == null || el == undefined) return;
      el.scrollIntoView({
        behavior: 'auto',
        inline: 'center',
        block: 'nearest',
      });
    }, 10);
    this.GetNameResults();
  }

  public GotoYear(year: string): void {
    document.getElementById(`release-year-${year}`).scrollIntoView({
      behavior: 'auto',
      inline: 'center',
      block: 'nearest',
    });
    this.router.navigate([`new-release/${year}`]);
  }

  public getReleaseNavOptions(): { year: string; before: boolean }[] {
    var currentRelease = this.colourBannerMap.findIndex(
      (c) => c.year === this.releaseYear
    );
    if (currentRelease == -1) return [];
    if (currentRelease == 0)
      return [
        {year: this.colourBannerMap[currentRelease + 1].year, before: false},
      ];
    if (currentRelease == this.colourBannerMap.length - 1)
      return [
        {year: this.colourBannerMap[currentRelease - 1].year, before: true},
      ];
    return [
      {year: this.colourBannerMap[currentRelease - 1].year, before: true},
      {year: this.colourBannerMap[currentRelease + 1].year, before: false},
    ];
  }

  public signUpWithEmail(email): void {
    this.customSignUpTrigger.emit(email);
  }

  public isFutureRelease(): boolean {
    return [].findIndex((x) => x === this.releaseYear.toString()) > -1;
  }

  public hasBannedPlates(): boolean {
    const bi = this.getBannerInfo();
    if (bi == null) return false;
    if (bi.bannedList === undefined || bi.bannedList === null) return false;
    return bi.bannedList.length > 0;
  }

  public getBannerInfo(): {
    year: string;
    colour: string;
    desktopImage: string;
    mobileImage: string;
    resultImage: string;
    resultPlate: string;
    term?: string;
    result: NewReleaseResult;
    bannedList?: string[];
    backgroundPosition?: string;
  } {
    const bi = this.colourBannerMap.find((y) => y.year == this.releaseYear);
    return bi;
  }

  public currentMatrix(): { width: number; before: number; during: number } {
    if (!this.showInlineImage) return {width: 0, before: 0, during: 0};
    var curWidth = window.innerWidth;
    var cr = this.resultMapMatris.find((r) => curWidth >= r.width);
    return cr;
  }

  public resultsBefore(): NewReleaseResult[] {
    return this.termReleaseResults.data.slice(0, this.currentMatrix().before);
  }

  public resultsDuring(): NewReleaseResult[] {
    return this.termReleaseResults.data.slice(
      this.currentMatrix().before,
      this.currentMatrix().before + this.currentMatrix().during
    );
  }

  public resultsAfter(): NewReleaseResult[] {
    if (this.getBannerInfo().result)
      return this.termReleaseResults.data.slice(
        this.currentMatrix().before + this.currentMatrix().during
      );
    else return this.termReleaseResults.data; // show all if we dont have a result image
  }

  private GetNameResults(): void {
    if (this.releaseYear == null) return;
    this.nameReleaseResults.SetLoading(true);
    this.searchService.getNewReleaseName(
      this.releaseYear,
      (res: NewReleaseResult[]) => {
        res = this.registrationService.formatNewReleaseRegistrations(res);
        this.nameReleaseResults.Update(
          false,
          res.sort((a, b) => a.registration.localeCompare(b.registration))
        );
        this.setAlphabet(this.currentAlphabet);
        this.GetTermResults();
      }
    );
  }

  private GetTermResults(): void {
    if (this.releaseYear == null) return;
    this.termReleaseResults.SetLoading(true);
    this.searchService.getNewRelease(
      this.releaseYear,
      'english',
      (res: NewReleaseResult[]) => {
        res = this.registrationService.formatNewReleaseRegistrations(res);
        const pageCustomBanner = this.getBannerInfo();
        if (pageCustomBanner) {
          //console.log('try and get data for result', pageCustomBanner)

          var featured = res.find(
            (r) => r.registration === this.getBannerInfo().resultPlate
          );

          if (featured) {
            this.getBannerInfo().result = featured;
            res = res.filter((r) => r.registration !== featured.registration);
          } else {
            this.getBannerInfo().result = {
              registration: pageCustomBanner.resultPlate,
              formattedRegistration: pageCustomBanner.resultPlate,
              owner: -1,
              term: pageCustomBanner.term,
              index: -1,
              price: -1,
              notified: false,
              favourite: false
            };
          }
        }
        this.termReleaseResults.Update(false, res);
        this.TermSortChange(this.termSorting, "");

        this.filterUpdate.emit(this.searchFilters);
      }
    );
  }

  public TermSortChange(e: DropdownOption, key: string): void {
    if (e === undefined) return;
    this.termSorting = e;
    if (this.termSorting.value === 'A-Z')
      this.termReleaseResults.Update(
        false,
        this.termReleaseResults.data.sort((a, b) =>
          a.registration.localeCompare(b.registration)
        )
      );
    else if (this.termSorting.value === 'Z-A')
      this.termReleaseResults.Update(
        false,
        this.termReleaseResults.data.sort((a, b) =>
          b.registration.localeCompare(a.registration)
        )
      );
    else if (this.termSorting.value === 'HIGH-TO-LOW')
      this.termReleaseResults.Update(
        false,
        this.termReleaseResults.data.sort((a, b) => b.price - a.price)
      );
    else if (this.termSorting.value === 'LOW-TO-HIGH')
      this.termReleaseResults.Update(
        false,
        this.termReleaseResults.data.sort((a, b) => a.price - b.price)
      );
  }

  public setAlphabet(letter: string): void {
    this.currentAlphabet = letter;
    this.namesFiltered = this.nameReleaseResults.data.filter((p) =>
      p.registration.toUpperCase().startsWith(letter.toUpperCase())
    );
  }

  public notifyRegistration(reg: NewReleaseResult): void {
    if (this.notifiying) return;
    this.notifiying = true;
    reg.notified = !reg.notified; // UI update
    this.userService.notifyRegistrationString(
      reg.registration,
      (notifs: Registration[]) => {
        var _filteredNotifies = notifs.filter(
          (f) =>
            f.registration.replace(' ', '') == reg.registration.replace(' ', '')
        );
        reg.notified = _filteredNotifies && _filteredNotifies.length > 0;
        this.notifiying = false;
      }
    );
  }

  public favouriteRegistration(reg: NewReleaseResult): void {
    if (this.saving) return;
    this.saving = true;
    reg.favourite = !reg.favourite; // UI update
    this.userService.favouriteRegistrationString(
      reg.registration,
      (favs: Registration[]) => {
        var _filteredFavourites = favs.filter(
          (f) =>
            f.registration.replace(' ', '') == reg.registration.replace(' ', '')
        );
        reg.favourite = _filteredFavourites && _filteredFavourites.length > 0;
        this.saving = false;
      }
    );
  }
}
